module.exports = "/_next/static/images/456c21b179a6cb729d7760c206fb64b2-hero-experiment.jpg";